import ButtonOptions from "%/dynamic-component-editor/bundles/button-options";
import ButtonBorderOptions from "%/dynamic-component-editor/bundles/button-border-options";
import ButtonType from "%/dynamic-component-editor/options/button-type";
import ButtonSize from "%/dynamic-component-editor/options/button-size";
import Icon from "%/dynamic-component-editor/options/icon";
import IconPosition from "%/dynamic-component-editor/options/icon-position";
import ButtonAction from "%/dynamic-component-editor/options/button-action";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import BorderRadius from "%/dynamic-component-editor/options/border-radius";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import LinkType from "%/dynamic-component-editor/options/link-type";
import {
  TextWithoutBrandingElementMixin,
} from "%/dynamic-component-editor/standard-elements/text-element/text-without-branding-element-mixin";
import EffectsOptions from "%/dynamic-component-editor/bundles/effects-options";
import BackgroundGradient from "%/dynamic-component-editor/options/background-gradient";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import BackgroundImage from "%/dynamic-component-editor/options/background-image";
import FontFamily from "%/dynamic-component-editor/options/font-family";
import FontColor from "%/dynamic-component-editor/options/font-color";
import FontSize from "%/dynamic-component-editor/options/font-size";
import FontWeight from "%/dynamic-component-editor/options/font-weight";
import {
  SharedButtonComputedStylesMixin,
} from "%/dynamic-component-editor/standard-elements/button-element/shared-button-computed-styles-mixin";
import ButtonBranding from "%/dynamic-component-editor/classes/branding/button-branding";

export const SmartFeedButtonElementMixin = {
  elementPanelSettings: {
    displayIcon: "message",
    elementType: "element",
  },
  brandingType: ButtonBranding,
  mixins: [TextWithoutBrandingElementMixin, DynamicElementMixin, SharedButtonComputedStylesMixin],
  props: {
    handleCustomClick: {
      type: Function,
      required: false,
      default: null,
    },
  },
  optionsOrder: [
    "button",
    "click-action",
  ],
  options: [
    new BackgroundColor(undefined, true, true),
    new BackgroundGradient(undefined, true, true),
    new BackgroundImage(undefined, true, true),
    new FontFamily(undefined, true, true),
    new FontColor(undefined, true, true),
    new FontSize(undefined, true, true),
    new FontWeight(undefined, true, true),
  ],
  optionBundles: [
    new EffectsOptions({}, {
      "text-shadow": true,
      "box-shadow": true,
    }),
    new SpacingOptions({}, {
      "padding": true,
      "margins": true,
    }),
    new ButtonOptions({}, {}, "See More Button"),
    ButtonBorderOptions,
  ],
  data() {
    return {
      ButtonType,
      ButtonSize,
      Icon,
      IconPosition,
      ButtonAction,
      BorderRadius,
      LayoutHeight,
      LayoutWidth,
      LinkType,
    };
  },
};
